import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, ArrowLeft } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const SECTIONS = [
  {
    id: "importancia",
    title: "Por que a Leitura Deste Documento é Importante?",
    body: (
      <p>
        Para realizar as suas atividades com segurança, a <strong>VIAGENS ORION</strong> está comprometida com a proteção dos dados pessoais dos usuários das plataformas e serviços da <strong>VIAGENS ORION</strong> em todos os momentos, a partir dos preceitos da Lei nº 13.709/18, também conhecida como Lei Geral de Proteção de Dados – LGPD. A leitura deste documento permite, através de uma linguagem simples, o conhecimento acerca das finalidades de utilização dos dados pessoais dos usuários nas plataformas e serviços oferecidos por <strong>VIAGENS ORION</strong>, e de como estes dados serão utilizados ou compartilhados com terceiros. Ao utilizar os serviços ou plataformas da <strong>VIAGENS ORION</strong>, o usuário confirma que leu e compreendeu todos os Termos e Políticas aplicáveis, e concorda em ficar a eles vinculado.
      </p>
    ),
  },
  {
    id: "cookies",
    title: "Uso dos Cookies",
    body: (
      <p>
        Os cookies são geralmente pequenos arquivos de texto que são armazenados no diretório do navegador do computador do usuário ou nas subpastas de dados do navegador. A <strong>VIAGENS ORION</strong> não coleta ou utiliza quaisquer cookies em suas plataformas e serviços sem o aceite. Todas as suas informações pessoais recolhidas serão usadas para ajudar a tornar o seu acesso em nosso site mais produtivo e agradável possível. A garantia da confidencialidade dos dados pessoais dos utilizadores do nosso site é importante para a Viagens Orion. Todas as informações pessoais relativas a membros, assinantes, clientes ou visitantes que usem a Viagens Orion serão tratadas em concordância com a Lei da Proteção de Dados Pessoais de 14 de agosto de 2018 (Lei nº 13.709/2018). A informação pessoal recolhida pode incluir o seu nome, e-mail, número de telefone e/ou telemóvel, morada, data de nascimento e/ou outros. O uso da Viagens Orion pressupõe a aceitação deste Acordo de privacidade. A equipe da Viagens Orion reserva-se ao direito de alterar este acordo sem aviso prévio. Deste modo, recomendamos que consulte a nossa política de privacidade com regularidade de forma a estar sempre atualizado.
      </p>
    ),
  },
  {
    id: "anuncios",
    title: "Os Anúncios",
    body: (
      <p>
        Tal como outros diversos websites, coletamos e utilizamos informação contida nos anúncios. A informação contida nos anúncios inclui o seu endereço IP (Internet Protocol), o seu ISP (Internet Service Provider), o browser que utilizou ao visitar o nosso website (como o Google Chrome, Safari ou Firefox), o tempo da sua visita e que páginas visitou dentro do nosso website.
      </p>
    ),
  },
  {
    id: "doubleclick",
    title: "Cookie DoubleClick Dart",
    body: (
      <ul className="list-disc ml-5 space-y-1">
        <li>O Google, como fornecedor de terceiros, utiliza cookies para exibir anúncios no nosso website;</li>
        <li>Com o cookie DART, o Google pode exibir anúncios com base nas visitas que o leitor fez a outros websites na Internet;</li>
        <li>Os utilizadores podem desativar o cookie DART visitando a <a className="text-orion-orange hover:underline" href="https://policies.google.com/technologies/ads" target="_blank" rel="noreferrer">Política de privacidade da rede de conteúdo dos anúncios do Google</a>.</li>
      </ul>
    ),
  },
  {
    id: "web-beacons",
    title: "Os Cookies e Web Beacons",
    body: (
      <p>
        Utilizamos cookies para armazenar informação, tais como as suas preferências pessoais quando visita o nosso website. Isto poderá incluir um simples popup, ou uma ligação em vários serviços que providenciamos, tais como fóruns. Em adição também utilizamos publicidade de terceiros no nosso website para suportar os custos de manutenção. Alguns destes publicitários poderão utilizar tecnologias como os cookies e/ou web beacons quando publicitam no nosso website, o que fará com que esses publicitários (como o Google através do Google AdSense) também recebam a sua informação pessoal, como o endereço IP, o seu ISP, o seu browser, etc. Esta função é geralmente utilizada para geotargeting (mostrar publicidade de São Paulo apenas aos leitores oriundos de São Paulo, por exemplo) ou apresentar publicidade direcionada a um tipo de utilizador. Você detém o poder de desligar os seus cookies nas opções do seu browser, ou efetuando alterações em ferramentas de programas Anti-Vírus. No entanto, isso poderá alterar a forma como interage com o nosso website ou outros websites.
      </p>
    ),
  },
  {
    id: "terceiros",
    title: "Ligações a Sites de Terceiros",
    body: (
      <p>
        A Viagens Orion possui ligações para outros sites, os quais, a nosso ver, podem conter informações e ferramentas úteis para os nossos visitantes. A nossa política de privacidade não é aplicada a sites de terceiros; caso visite outro site a partir do nosso, deverá ler a política de privacidade do mesmo. Não nos responsabilizamos pela política de privacidade ou conteúdo presente nesses sites.
      </p>
    ),
  },
  {
    id: "coleta",
    title: "Como as Informações Pessoais dos Usuários são coletadas?",
    body: (
      <>
        <p>A <strong>VIAGENS ORION</strong> coleta informações pessoais sobre os usuários de suas plataformas e serviços através dos seguintes meios:</p>
        <ul className="list-disc ml-5 space-y-1 mt-3">
          <li>Durante a contratação ou após a contratação, diretamente com o cliente;</li>
          <li>Preenchimento de formulários online;</li>
          <li>Através de sites de entes públicos ou privados, tais como sites de governos e agências de crédito;</li>
          <li>Ao realizar a compra de algum pacote de viagem ou produto.</li>
        </ul>
      </>
    ),
  },
  {
    id: "uso",
    title: "Como as Informações Pessoais dos Usuários serão utilizadas?",
    body: (
      <>
        <p>Só serão utilizadas as informações pessoais dos usuários das plataformas e serviços da <strong>VIAGENS ORION</strong> quando a Lei Geral de Proteção de Dados – LGPD ou outra regulamentação assim o permitir. No geral, as informações pessoais dos usuários serão utilizadas pela <strong>VIAGENS ORION</strong> em uma ou mais das seguintes circunstâncias:</p>
        <ul className="list-disc ml-5 space-y-1 mt-3">
          <li>Para a execução de atividades pré-contratuais ou contratuais relacionadas com a prestação de serviços, conforme previsão do art. 7º, inciso V da LGPD;</li>
          <li>Para o cumprimento de uma obrigação legal ou regulatória, conforme previsão do art. 7º, inciso II da LGPD;</li>
          <li>Para nosso legítimo interesse, conforme previsão do art. 7º, inciso IX da LGPD;</li>
          <li>Para utilização como prova em processos judiciais ou administrativos, conforme previsão do art. 7º, inciso VI da LGPD.</li>
        </ul>
      </>
    ),
  },
  {
    id: "finalidade",
    title: "Sobre a Mudança de Finalidade",
    body: (
      <p>
        As informações pessoais dos usuários só serão utilizadas para as finalidades pelas quais elas foram coletadas inicialmente, a menos que haja a necessidade de utilização por outra razão que seja compatível com o propósito original. No que diz respeito ao consentimento, caso a utilização das informações pessoais seja necessária para um propósito não relacionado com a finalidade original, a <strong>VIAGENS ORION</strong> realizará uma notificação com as informações acerca da nova base legal de tratamento utilizada.
      </p>
    ),
  },
  {
    id: "automatizada",
    title: "Sobre a Tomada de Decisões Automatizadas",
    body: (
      <>
        <p>A tomada de decisão automatizada ocorre quando um sistema eletrônico se utiliza de determinados dados pessoais para tomar uma decisão sem a necessidade de intervenção humana. Esta automatização da tomada de decisões será executada nas seguintes circunstâncias:</p>
        <ul className="list-disc ml-5 space-y-1 mt-3">
          <li>Quando necessário para executar o contrato firmado com a <strong>VIAGENS ORION</strong>;</li>
          <li>Em circunstâncias limitadas, com o consentimento do usuário;</li>
          <li>Se tomada uma decisão automatizada com base em quaisquer das informações pessoais sensíveis do usuário, deverá ser obtido o seu consentimento expresso ou outra hipótese legal de tratamento contida no art. 11 da LGPD (Lei Geral de Proteção de Dados Pessoais).</li>
        </ul>
      </>
    ),
  },
  {
    id: "compartilhamento",
    title: "Sobre o Compartilhamento com Terceiros",
    body: (
      <p>
        Poderá ser realizado o compartilhamento dos dados pessoais dos usuários com terceiros, fornecedores de quaisquer produtos ou serviços para a <strong>VIAGENS ORION</strong>. É contratualmente exigido que estes terceiros respeitem a segurança dos dados pessoais dos titulares e realizem o tratamento de acordo com a LGPD (Lei Geral de Proteção de Dados Pessoais). Os dados pessoais dos titulares poderão ser compartilhados com terceiros quando exigido por lei, para a execução do contrato ou sob algum outro interesse legítimo no compartilhamento. Contudo, neste último caso, haverá uma comunicação prévia sobre o compartilhamento dos dados pessoais dos titulares.
      </p>
    ),
  },
  {
    id: "seguranca",
    title: "Sobre a Segurança dos Dados Pessoais",
    body: (
      <p>
        A <strong>VIAGENS ORION</strong> instaurou as medidas de segurança apropriadas para impedir que as informações pessoais dos titulares sejam perdidas, adulteradas, divulgadas ou acessadas de forma não autorizada. O acesso a qualquer uma das informações pessoais dos titulares é limitado apenas aos integrantes da <strong>VIAGENS ORION</strong> que realmente precisarem ter o conhecimento destas informações, as quais somente serão processadas sob as instruções da <strong>VIAGENS ORION</strong>, com todos os envolvidos sujeitos a um acordo de confidencialidade. Existem procedimentos para lidar com quaisquer suspeitas de violação de segurança de dados, e haverá sempre uma notificação na ocorrência de algum incidente relevante.
      </p>
    ),
  },
  {
    id: "retencao",
    title: "Sobre o Período de Retenção dos Dados Pessoais",
    body: (
      <p>
        Só serão retidas as informações pessoais dos titulares pelo tempo necessário para cumprir os propósitos adequados, incluindo os dados pessoais necessários para satisfazer quaisquer requisitos ou determinações legais. A fim de definir o período de retenção adequado para um determinado dado pessoal de um titular, são considerados pela <strong>VIAGENS ORION</strong> a quantidade, a natureza e a sensibilidade e o risco potencial de dano pelo uso ou divulgação não autorizada desses dados pessoais, bem como a finalidade de tratamento utilizada pela <strong>VIAGENS ORION</strong>.
      </p>
    ),
  },
  {
    id: "direitos",
    title: "Sobre os Direitos dos Titulares de Dados",
    body: (
      <>
        <p>São direitos dos titulares de dados pessoais:</p>
        <ul className="list-disc ml-5 space-y-1 mt-3">
          <li>Solicitar acesso às informações pessoais. Isso permite ao titular receber uma cópia de todas as informações pessoais que a <strong>VIAGENS ORION</strong> detém sobre ele, a qualquer tempo;</li>
          <li>Solicitar a correção das suas informações pessoais. Isso permite ao titular pedir para a <strong>VIAGENS ORION</strong> corrigir qualquer informação incompleta ou imprecisa;</li>
          <li>Solicitar a exclusão das suas informações pessoais. Isso permite ao titular pedir para a <strong>VIAGENS ORION</strong> excluir ou remover informações pessoais cujo tratamento esteja condicionado ao seu consentimento;</li>
          <li>Solicitar a interrupção do tratamento de dados sob a finalidade do legítimo interesse;</li>
          <li>Solicitar a restrição de processamento de suas informações pessoais;</li>
          <li>Solicitar a portabilidade de suas informações pessoais para outra pessoa ou empresa.</li>
        </ul>
        <p className="mt-4">
          Caso o usuário queira exercer qualquer um destes direitos, poderá entrar em contato através do e-mail{" "}
          <a className="text-orion-orange hover:underline" href="mailto:contato@viagensorion.com.br">contato@viagensorion.com.br</a>.
        </p>
      </>
    ),
  },
  {
    id: "consentimento",
    title: "Sobre a Retirada do Consentimento",
    body: (
      <p>
        Nas circunstâncias limitadas em que for necessário o consentimento do titular de dados pessoais para o tratamento, é um direito do titular a retirada do seu consentimento, o que pode ser realizado a qualquer momento. Para retirar o seu consentimento, o titular deverá entrar em contato através do e-mail{" "}
        <a className="text-orion-orange hover:underline" href="mailto:contato@viagensorion.com.br">contato@viagensorion.com.br</a>.
      </p>
    ),
  },
  {
    id: "reclamacoes",
    title: "Sobre Reclamações ou Consultas",
    body: (
      <p>
        Caso haja quaisquer dúvidas sobre esta política de privacidade ou de como a <strong>VIAGENS ORION</strong> lida com informações pessoais, o titular deve entrar em contato através do e-mail{" "}
        <a className="text-orion-orange hover:underline" href="mailto:contato@viagensorion.com.br">contato@viagensorion.com.br</a>. O titular de dados tem o direito de fazer uma reclamação a qualquer momento perante a Autoridade Nacional de Proteção de Dados (ANPD).
      </p>
    ),
  },
  {
    id: "alteracoes",
    title: "Alterações na Política de Privacidade",
    body: (
      <p>
        A <strong>VIAGENS ORION</strong> se reserva o direito de atualizar este aviso a qualquer momento. Serão informadas ao titular de dados quaisquer atualizações ou modificações substanciais neste documento ou em quaisquer políticas relevantes da <strong>VIAGENS ORION</strong>.
      </p>
    ),
  },
];

export default function Privacidade() {
  useEffect(() => {
    document.title = "Política de Privacidade | Viagens Orion";
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", "Política de Privacidade da Viagens Orion — como coletamos, usamos e protegemos dados pessoais em conformidade com a LGPD.");
  }, []);

  return (
    <main className="bg-white text-orion-purple min-h-screen flex flex-col" data-testid="privacy-page">
      <Header />
      {/* Hero */}
      <section className="bg-orion-purple text-white">
        <div className="container-orion py-16 md:py-20">
          <Link to="/" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-orion-gold/80 hover:text-orion-orange mb-6" data-testid="privacy-back">
            <ArrowLeft size={14} /> Voltar ao Blog
          </Link>
          <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.32em] text-orion-gold mb-5">
            <ShieldCheck size={14} /> Documento legal · LGPD
          </div>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-tight">Política de Privacidade</h1>
          <p className="mt-5 text-white/70 text-sm max-w-2xl">
            Última atualização: {new Date().toLocaleDateString("pt-BR", { day: "2-digit", month: "long", year: "numeric" })}.
            Este documento descreve como a Viagens Orion coleta, usa, compartilha e protege os dados pessoais dos usuários do seu site e serviços.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="container-orion py-14 md:py-20 grid lg:grid-cols-[260px_1fr] gap-12">
        {/* Sticky TOC */}
        <aside className="hidden lg:block">
          <div className="sticky top-28 text-xs">
            <div className="uppercase tracking-[0.28em] text-orion-purple/50 mb-3">Sumário</div>
            <ul className="space-y-2">
              {SECTIONS.map((s) => (
                <li key={s.id}>
                  <a href={`#${s.id}`} className="text-orion-purple/70 hover:text-orion-orange transition-colors leading-snug block">
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </aside>

        {/* Body */}
        <article className="max-w-3xl text-orion-purple/85 leading-relaxed text-[15px] space-y-10">
          {SECTIONS.map((s) => (
            <section key={s.id} id={s.id} className="scroll-mt-28">
              <h2 className="font-serif text-2xl md:text-3xl text-orion-purple mb-3">{s.title}</h2>
              <div className="space-y-3">{s.body}</div>
            </section>
          ))}

          <div className="border-t border-orion-purple/10 pt-8 mt-12 text-sm text-orion-purple/60">
            Dúvidas? Fale conosco pelo e-mail{" "}
            <a className="text-orion-orange hover:underline font-medium" href="mailto:contato@viagensorion.com.br" data-testid="privacy-contact-email">
              contato@viagensorion.com.br
            </a>.
          </div>
        </article>
      </section>
      <Footer />
    </main>
  );
}
